import UpdateStatusIcon from '@/components/PulseCards/UpdateStatusIcon'
import { shortAgo } from '@/features/pulseDemo/updateLabels'
import browse from './HomeNavBrowse.module.scss'
import styles from './pulseRail.module.scss'

/**
 * One run result under Updates: where it came from over what happened and when.
 * Only outcomes that need the user get a status icon, so the rail stays quiet.
 */
export default function HomeNavUpdateRow({ update, active = false, onSelect }) {
  return (
    <button
      type="button"
      className={`${browse.scheduleRow}${active ? ` ${browse.scheduleRowActive}` : ''}`}
      aria-pressed={active}
      onClick={() => onSelect(update.id)}
    >
      <span className={browse.scheduleText}>
        <span className={browse.scheduleTitle}>{update.sourceTitle}</span>
        <span className={browse.scheduleCadence}>
          {update.headline} · {shortAgo(update.at)}
        </span>
      </span>
      {update.status === 'done' ? null : <UpdateStatusIcon status={update.status} />}
      {update.read ? null : <span className={styles.unreadDot} role="img" aria-label="Unread" />}
    </button>
  )
}
